module.exports = __webpack_public_path__ + "media/goforajourney/img/france-card-ce39094ba3f5742a777f40e8e748efe5.webp";